document.addEventListener("DOMContentLoaded", () => {
    const scheduleNowButton = document.querySelector("#shedule-now-button");
    const scheduleNowButtonClose = document.querySelector("#shedule-now-button-close");
    const scheduleNowPopupWrapper = document.querySelector("#shedule-now-popup-wrapper");
    const scheduleNowSelect = document.querySelector("#schedule-now-select");
    const scheduleIframe = document.querySelector("#schedule-now-iframe");

    if (scheduleNowButton !== null) {
        scheduleNowButton.addEventListener("click", event => {
            event.preventDefault();
            document.body.classList.add("u-overflow-hidden");
            scheduleNowPopupWrapper.classList.add("active");
        });

        scheduleNowButtonClose.addEventListener("click", event => {
            event.preventDefault();

            document.body.classList.remove("u-overflow-hidden");
            scheduleNowPopupWrapper.classList.remove("active");
        });

        scheduleNowSelect.addEventListener("change", event => {
            const currentSelect = event.target;
            scheduleIframe.src = currentSelect.value;
        });
    }
});
